import React, { FC, ReactNode } from "react";
import { Scrollbar } from "react-scrollbars-custom";
import classNames from "classnames";
import { useWatchState } from "../../../hooks";

export interface IScrollBarProps {
  classes?: { root?: string; wrapper?: string; track?: string; thumb?: string };
  children?: ReactNode;
  height?: number;
}
const ScrollBar: FC<IScrollBarProps> = ({ children, classes, height }) => {
  const [contentHeight, setContentHeight] = useWatchState<number>({ value: 0 });
  const renderer = (props) => {
    const { elementRef, ...restProps } = props;
    return (
      <div
        {...restProps}
        ref={elementRef}
        className={classNames("scrollbar", classes?.root)}
        data-testid="scrollbar"
      />
    );
  };

  const wrapperProps = {
    renderer: (props) => {
      const { elementRef, ...restProps } = props;
      return (
        <div
          {...restProps}
          ref={elementRef}
          className={classNames("scrollbar-wrapper", classes?.wrapper)}
          data-testid="scrollbar-wrapper"
        />
      );
    },
  };

  const trackXProps = {
    renderer: (props) => {
      const { elementRef, ...restProps } = props;
      return (
        <div
          {...restProps}
          ref={elementRef}
          className={classNames("scrollbar-track", classes?.track)}
          data-testid="scrollbar-track"
        />
      );
    },
  };
  const thumbXProps = {
    renderer: (props) => {
      const { elementRef, ...restProps } = props;
      return (
        <div
          {...restProps}
          ref={elementRef}
          className={classNames("scrollbar-thumb", classes?.thumb)}
          data-testid="scrollbar-thumb"
        />
      );
    },
  };

  return (
    <Scrollbar
      style={{ height: height ?? contentHeight + 20 }}
      noDefaultStyles
      renderer={renderer}
      wrapperProps={wrapperProps}
      trackXProps={trackXProps}
      thumbXProps={thumbXProps}
      className={classes?.root}
      onUpdate={(values) => setContentHeight(values.contentScrollHeight)}
    >
      {children}
    </Scrollbar>
  );
};

export default ScrollBar;
